import { env } from '../env'

/** PayPal is a first-class checkout rail in local/dev and when the public flag is on. */
export function isPaypalOffered(): boolean {
  return env.isPayPalEnabled || __DEV__
}
